import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PublishIcon from "@mui/icons-material/Publish";
import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import SuiTypography from "components/SuiTypography";
import Prompt from "components/UpStyled/Prompt";
import { AccountContext } from "context/account";
import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "services/api";

const labelProps = {
  elevation: 0,
  sx: {
    overflow: "visible",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
    mt: 1.5,
    "& .MuiAvatar-root": {
      width: 32,
      height: 32,
      ml: -0.5,
      mr: 1,
    },
    "&:before": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: "background.paper",
      transform: "translateY(-50%) rotate(45deg)",
      zIndex: 0,
    },
  },
};

const BlogOptions = ({ blog, refreshParent }) => {
  // console.log('blog', blog)

  const account = useContext(AccountContext);
  if (blog && blog.owner_id != account.id) return <></>;

  const [openMenu, setOpenMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [dialogVisible, setDialogVisible] = useState(false);
  const [action, setAction] = useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
    event.stopPropagation();
  };
  const handleClose = (event) => {
    setAnchorEl(null);
    setOpenMenu(false);
    event.stopPropagation();
  };
  let navigate = useNavigate();
  const handleAction = (event) => {
    if (action == "Delete")
      api.blog.delete(blog.id).then(({ data }) => {
        if (refreshParent) refreshParent();
        else navigate(`/social/blog`, { replace: true });
        return data;
      });
    else
      api.blog.publish(blog.id).then(({ data }) => {
        if (refreshParent) refreshParent();
        return data;
      });
  };

  return (
    <>
      <Tooltip title="Options" placement="top-start">
        <IconButton
          onClick={handleClick}
          size="small"
          aria-controls={openMenu ? "blog-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={openMenu ? "true" : undefined}
        >
          <MoreVertIcon
            fontSize="small"
            color="inherit"
            className="border-none hover:bg-transparent"
          />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="blog-menu"
        open={openMenu}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={labelProps}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <Link to={`/social/blog?editblogid=${blog.id}`} target="_self" style={{ color: "inherit" }}>
          <MenuItem>
            <EditIcon className="align-middle" fontSize="small" />
            <SuiTypography>&nbsp;&nbsp;Edit</SuiTypography>
          </MenuItem>
        </Link>
        {blog?.status == "draft" && (
          <MenuItem
            onClick={(e) => {
              setAction("Publish");
              setDialogVisible(true);
            }}
          >
            <PublishIcon className="align-middle" fontSize="small" />
            <SuiTypography>&nbsp;&nbsp;Publish</SuiTypography>
          </MenuItem>
        )}
        <MenuItem
          onClick={(e) => {
            setAction("Delete");
            setDialogVisible(true);
          }}
        >
          <DeleteIcon className="align-middle" fontSize="small" />
          <SuiTypography>&nbsp;&nbsp;Delete</SuiTypography>
        </MenuItem>
      </Menu>
      <Prompt
        heading={action + " Blog"}
        text={`Are you sure you want to ${action.toLowerCase()} this blog?`}
        visible={dialogVisible}
        okText={action}
        okColor="dark"
        handleOk={() => {
          setDialogVisible(false);
          handleAction();
        }}
        handleClose={() => setDialogVisible(false)}
      />
    </>
  );
};

export default BlogOptions;
